import { render } from "./StudyMaterialsPage.vue?vue&type=template&id=ddec80b8&scoped=true"
import script from "./StudyMaterialsPage.vue?vue&type=script&lang=js"
export * from "./StudyMaterialsPage.vue?vue&type=script&lang=js"

import "./StudyMaterialsPage.vue?vue&type=style&index=0&id=ddec80b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddec80b8"]])

export default __exports__